export const WHATSAPP_PHONE = "34688642601"; // +34 688 642 601

export const buildWhatsAppUrl = (message) => {
    const text = encodeURIComponent(message || "");
    return `https://wa.me/${WHATSAPP_PHONE}?text=${text}`;
};

export const openWhatsApp = (message) => {
    const url = buildWhatsAppUrl(message);
    window.open(url, "_blank", "noopener,noreferrer");
};

export const DEFAULT_HELLO =
    "Hola Silvia, me gustaría tener más información sobre tus sesiones.";
